
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import Vue from "vue";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
export default Vue.extend({
	data() {
		return {
			lang: "",
			toEditStyle: null as null | keyof ReminderLayout
		};
	},
	props: {
		layout: Object as () => ReminderLayout,
	},
	methods: {
		editStyle(style: keyof ReminderLayout) {
			this.toEditStyle = style;
		}
	},
	components: {
		AppCustomLanguageSelect,
		AppStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
